import React, { useContext, useEffect } from 'react';
import { AuthContext } from '@starterapp/shared-services/authentication/AuthContext';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router';

const Authenticate = () => {
    const location = useLocation();
    const history = useHistory();
    const { authenticateUser } = useContext(AuthContext);
    const url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PATH}/`

    useEffect(() => {
        (async () => {
            const userParams = location.search ? location.search.substring(1) : null;
            const isAuthenticated = await authenticateUser(userParams);

            if (isAuthenticated) {
                sessionStorage.setItem('isAuthenticated', true);
                const routeName = localStorage.getItem('redirectTo');
                const routeUrl = localStorage.getItem('redirectUrl');

                if (routeName === 'validateCard') {
                    history.push(routeUrl);
                } else
                   history.push(routeName);
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            Authenticating...
        </div>
    );
};

export default Authenticate;
